import React, { useEffect, useState } from "react";
import {
    Box,
    Button,
    Typography,
    Icon,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";
import AptaTable from "examples/AptaTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDTypography from "components/MDTypography";
import axios from "axios";
import { SERVER_URL } from "constants/constant";
import Swal from "sweetalert2";

function Categories() {
    const [indianCategories, setIndianCategories] = useState([]);
    const [foreignCategories, setForeignCategories] = useState([]);
    const [editModalOpen, setEditModalOpen] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [newPrice, setNewPrice] = useState("");

    // Fetch categories
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${SERVER_URL}/regi-category/get-all`);
            const data = response.data;
            setIndianCategories(data?.filter(i => i?.regiCategoryType === "Indian_Delegate"));
            setForeignCategories(data?.filter(i => i?.regiCategoryType === "Foreign_Delegate"));
        } catch (error) {
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    const handleEditClick = (category) => {
        setSelectedCategory(category);
        setNewPrice(category.price);
        setEditModalOpen(true);
    };

    const handleSavePrice = async () => {
        try {
            await axios.put(`${SERVER_URL}/regi-category/edit/${selectedCategory?._id}`, {
                regiCategoryType: selectedCategory?.regiCategoryType,
                regiCategoryName: selectedCategory?.regiCategoryName,
                price: newPrice,
            });
            Swal.fire({ title: 'Successfully updated price!', icon: 'success' })
            setEditModalOpen(false);
            fetchCategories();
        } catch (error) {
            Swal.fire({ title: 'Please try again!', icon: 'error' })

            console.error("Error updating price:", error);
        }
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />

            {/* Indian Categories Table */}
            <Typography variant="h5" gutterBottom>Indian Delegates</Typography>
            <AptaTable
                columns={["Name", "Price", "Actions"]}
                rows={indianCategories?.map((category) => ({
                    "Name": (
                        <MDTypography variant="button" fontWeight="medium">
                            {category?.regiCategoryName?.toUpperCase()}
                        </MDTypography>
                    ),
                    Price: `₹ ${category.price}`,
                    Actions: (
                        <Button color="info" onClick={() => handleEditClick(category)}>
                            <Icon color="info">edit</Icon>
                        </Button>
                    ),
                }))}
            />

            {/* Foreign Categories Table */}
            <Typography variant="h5" gutterBottom mt={4}>Foreign Delegates</Typography>
            <AptaTable
                columns={["Name", "Price", "Actions"]}
                rows={foreignCategories?.map((category) => ({
                    "Name": (
                        <MDTypography variant="button" fontWeight="medium">
                            {category?.regiCategoryName?.toUpperCase()}
                        </MDTypography>
                    ),
                    Price: `$ ${category.price}`,
                    Actions: (
                        <Button color="info" onClick={() => handleEditClick(category)}>
                            <Icon color="info">edit</Icon>
                        </Button>
                    ),
                }))}
            />

            {/* Edit Price Modal */}
            <Dialog open={editModalOpen} onClose={() => setEditModalOpen(false)}>
                <DialogTitle>Edit Price</DialogTitle>
                <DialogContent>
                    <TextField
                        label="New Price"
                        type="number"
                        fullWidth
                        value={newPrice}
                        onChange={(e) => setNewPrice(e.target.value)}
                        margin="normal"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setEditModalOpen(false)} color="primary">Cancel</Button>
                    <Button onClick={handleSavePrice} color="primary" variant="contained" style={{ color: 'white' }}>Save</Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
}

export default Categories;
